import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WeightStationsApi from '@/services/apiServiceModules/weightStationsApi'
const weightStationsApi = new WeightStationsApi()

export default class WeightStationsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WEIGHT_STATIONS, weightStationsApi, {
			useCache: true,
		})
	}
}
